<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('close')">
                <div class="modal-container-brouillon" @click.stop>
                    <div class="modal-header-brouillon">
                        {{ $t('_selectionner_un_brouillon_ou_') }}
                        <slot name="cross">
                            <v-icon style="float: right; top: 0.3vh;" @click="$emit('close')">mdi-close</v-icon>
                        </slot>
                    </div>

                    <div class="modal-body-brouillon">
                        <v-data-table 
                            class="brouillonTable" 
                            :items="brouillons" 
                            :headers="headerBrouillon"
                            :items-per-page="-1" 
                            @click:row="selectItem" 
                            fixed-header 
                            hide-default-footer 
                            :item-class="getRowClass"
                        >
                            <template v-slot:top>
                                <v-toolbar flat style="background-color:#F2F4F4">
                                    <v-toolbar-title> {{ $t('_brouillon_') }} </v-toolbar-title>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.updated_at="{ item }">
                                {{ formatDate(item.updated_at) }}
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <v-icon small @click.stop="deleteItem(item)">
                                    mdi-minus-box
                                </v-icon>
                            </template>
                        </v-data-table>
                    </div>

                    <div class="modal-footer-brouillon">
                        <v-btn style="float: right; background-color: #F49301; padding: 1vh; font-size: 1rem"
                            @click="$emit('new')">
                            {{ $t('_creer_nouveau_') }}
                        </v-btn>
                        <v-btn :disabled="inactif"
                            style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw ; font-size: 1rem;"
                            @click="$emit('use', selectionne)">
                            {{ $t('_selectionner_ce_brouillon_') }}
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import api from '@/api/api'

export default {
    async mounted() {
        await this.getDraft()
    },

    data() {
        return {
            selectionne: null,
            inactif: true,
            brouillons: [],
            headerBrouillon: [
                { key: 'name', text: this.$t('_nom_'), value: 'name' },
                { key: 'updated_at', text: this.$t('_date_de_creation_'), value: 'updated_at' },
                { key: 'actions', text: '', value: 'actions', sortable: false }
            ],
            utilisateur: null,
        }
    },

    methods: {
        // Formate la string ISO en format lisible (ex: 30/01/2026 15:35)
        formatDate(dateString) {
            if (!dateString) return ''
            const date = new Date(dateString)
            return date.toLocaleString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            })
        },

        // Récupère la liste des brouillons
        async getDraft() {
            try {
                this.utilisateur = (await api.currentUser()).data.id            
                const response = await api.get_all_drafts(this.utilisateur)
                this.brouillons = response.data
            }
            catch (error) {
                console.error("Erreur lors de la récupération des brouillons:", error)
                this.brouillons = []
            }
        },

        selectItem(item) {
            this.selectionne = item
            this.inactif = false
        },

        async deleteItem(item) {
            try {
                await api.delete_draft_from_id(this.utilisateur, item.id)
                
                if (this.selectionne && this.selectionne.id === item.id){
                    this.inactif = true
                    this.selectionne = null
                }
                
                const index = this.brouillons.indexOf(item)
                if (index > -1) {
                    this.brouillons.splice(index, 1)
                }
            } catch (error) {
                console.error("Erreur lors de la suppression:", error)
            }
        },

        getRowClass(item) {
            return item === this.selectionne ? 'highlighted-row' : ''
        }
    },
}
</script>

<style scoped>

.modal-container-brouillon {
    width: 70vw;
    height: auto;
    max-height: 80vh;
    min-height: 30vh;
    margin: 0px auto;
    padding: 2vh;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    position: relative;
    flex-direction: column;
}

.modal-header-brouillon {
    font-weight: bold;
    font-size: 1.5rem;
    color: #212121;
    height: fit-content;
}

.modal-body-brouillon {
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 1vh;
    padding-bottom: 3.5rem;
}

.modal-footer-brouillon {
    padding: 16px 16px;
    background-color: white;
    color: white;
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
}

.modal-body-brouillon .theme--light.v-data-table {
    border: 1px solid;
    border-color: rgba(47, 47, 47, 0.5);
    border-radius: 5px;
}

.modal-body-brouillon .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: unset;
}

.brouillonTable{
    height: 100%;
}

.brouillonTable >>> .highlighted-row {
  background-color: #d9d9d9 !important;
}
</style>